<template>
    <div class="com-top-header-wp">
        <div class="h-c w-1200">
            <div class="l-c">
                <p>你好，欢迎来到基于区域医联体模式的国产创新诊疗设备服务云平台!</p>
            </div>
            <div class="r-c">
                <p v-if="!userName" @click="routerToUrl('/register')">平台注册</p>
                <p v-if="!userName" @click="routerToUrl('/login')">登录</p>
                <p v-if="userName" style="color:#31A5D7;">{{userName}}</p>
                <!-- <p>个人中心</p> -->
                <el-dropdown v-if="userName" @command="handleCommand">
                <p>个人中心</p>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="editPassword">修改密码</el-dropdown-item>
                        <el-dropdown-item command="logout">注销</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <!-- <p>关于我们</p> -->
            </div>
        </div>
        

    </div>
</template>
<script>
export default {
    data(){
        return{
            userName:'',
        }
    },
    mounted(){
        this.initName();
    },
    methods:{
        initName(){
            this.userName=this.cookie.get('userRealName');
        },
        handleCommand (command) {
            switch(command){
                case 'editPassword':
                    this.goto()
                    break
                case 'logout':
                    this.handleLogout()
                    break
                default:
                    console.log(command)
                    break
            }
        },

        handleLogout(){
            
            this.post(this.api.logout).then(res=>{
                this.cookie.remove('token');
                this.cookie.remove('userRealName');
                this.cookie.remove('userID');
                this.userName='';
                this.routerToUrl('/login');
            }).catch(error=>{})
        },
        goto(){
            this.routerToUrl('/editPassword');
        }
    }   
}
</script>
<style lang="scss" scoped>
.com-top-header-wp{
    width:100%;
    height:40px;
    background: #F1F1F1;
}
p{
    margin:0;
    font-size: 14px;
    color:#434343;
}
.h-c{
    height:40px;
    margin:0 auto;
}
.l-c{
    // width: 400px;
    height:100%;
    float: left;
    p{
        width:100%;
        height:40px;
        line-height:40px;
    }
}
.r-c{
    height:100%;
    float: right;
    p{
        float: left;
        margin-left: 30px;
        height:40px;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
    }
}
</style>